import {useEffect} from "react"
import usePermissions from "../hooks/usePermissions"
import useModal from "../hooks/useModal";
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"

export default function Payments(){
    
    const {restrictSection}=usePermissions()
    useEffect(()=>{
        restrictSection("master","")
    },[])
    
    const {changeModal}=useModal()

    const edit=()=>{
        changeModal("payment-edit","",0)
    }

    return(
        <Section>
            <SectionHeader
                title="Medios de pago"
                intro="Formas de pago disponibles que pueden pertenecer a una tarjeta y entidad específicas."
                back=""
                button={{label:"Agregar",icon:"create",link:"",href:"",clickEvent:edit}}
                tabs={[
                    {label:"Medios de pago",labelShort:"Medios",to:"/c24/medios-de-pago"},
                    {label:"Tarjetas",to:"/c24/medios-de-pago/tarjetas"},
                    {label:"Entidades",to:"/c24/medios-de-pago/entidades"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"payments",
                    endpoint:"payments/list",
                    limit:0,
                    counter:{
                        singular:"medio de pago",
                        plural:"medios de pago"
                    },
                    action:{
                        mode:"modal",
                        context:"",
                        reference:"payment-edit"
                    }
                }} />
            </SectionContent>
        </Section>
    )
    
}